/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SexualHistory from './sexual-history';
import SexualHistoryDetail from './sexual-history-detail';
import SexualHistoryUpdate from './sexual-history-update';
import SexualHistoryDeleteDialog from './sexual-history-delete-dialog';

const SexualHistoryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SexualHistory />} />
    <Route path="new" element={<SexualHistoryUpdate />} />
    <Route path=":id">
      <Route index element={<SexualHistoryDetail />} />
      <Route path="edit" element={<SexualHistoryUpdate />} />
      <Route path="delete" element={<SexualHistoryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SexualHistoryRoutes;
